import React, { Component, createRef } from 'react';
import { fabric } from 'fabric';

class DrawingEditor extends Component {

    constructor(props) {
        super(props);
        this.canvasCont = createRef();
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));

        let { setCanvas } = this.props;
        
        this.canvasFb = new fabric.Canvas('mainCanvas', { isDrawingMode: true });
        setCanvas(this.canvasFb);
        
        let width = this.canvasCont.current.offsetWidth
        let height = this.canvasCont.current.offsetHeight
        this.canvasFb.setWidth(width - 10);
        this.canvasFb.setHeight(height - 10);
        this.canvasFb.freeDrawingBrush.width = 4;
        this.canvasFb.lineWidth = 4;
    }

    resize() {
        let newWidth = this.canvasCont.current ? this.canvasCont.current.offsetWidth : 300;
        let newHeight = this.canvasCont.current ? this.canvasCont.current.offsetHeight : 300;
        this.canvasFb.setWidth(newWidth - 10);
        this.canvasFb.setHeight(newHeight - 10);
    }

    render() {
        return (
            <div ref={this.canvasCont} style={{ width: '100%', height: '100%' }}>
                <canvas style={{ paddingBottom: '10px' }} id="mainCanvas"></canvas>
            </div>
        );
    }
}

export default DrawingEditor;